import { createAsyncThunk } from "@reduxjs/toolkit";
import { createCategory, editCategory, getAllCategory, deleteCategory} from "../../api/categorymanegment";

// Thunk action for get all user
export const createCategoryAction = createAsyncThunk(
  "category/create",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await createCategory(userData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk action for edit user
export const editCategoryAction = createAsyncThunk(
  "category/edit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await editCategory(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk action for get all user
export const getAllCategoryAction = createAsyncThunk(
  "category/getAll",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getAllCategory(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
// Thunk action for delelte employee
export const deleteCategoryAction = createAsyncThunk(
  "category/delete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await deleteCategory(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);